import firebase from "firebase/app";
import "firebase/firestore";

import { getCompanyRemoteData, getCompanyMetadata, getCompanyReviews } from '../../../db';

const getFiveNewestCompanies = async () => {
    let snapshot = await firebase.firestore().collection("company-data").get();
}

export const getCompanyData = async (companyName) => {
    let data = await getCompanyRemoteData(companyName);
    data.metadata = await getCompanyMetadata(companyName);
    data.reviews = await getCompanyReviews(companyName);
    return data;
}

// TODO: find ways to optimize this expensive query
export const getAllCompanyDataAggregated = async () => {
    try {
        let snapshot = await firebase.firestore().collection("company-data").get();
    
        const companyData = await Promise.all(
            snapshot.docs.map(async (doc) => {
              let data = doc.data();
              const companyInfoDoc = await firebase
                .firestore()
                .collection("company-data")
                .doc(data.companyName)
                .collection("metadata")
                .doc("company-info")
                .get();
              data.companyInfo = companyInfoDoc.data();
              return data;
            })
          );   
          
        return companyData;
    } catch (error) {
        console.log("error fetching aggregated company data: ", error);
    }
}

export const getAggregatedDataForCompanyName = async (companyName) => {
    try {
        let snapshot = await firebase.firestore().collection("company-data").doc(companyName).get();
        let data = snapshot.data();

        let coInfoData = await firebase
            .firestore()
            .collection("company-data")
            .doc(companyName)
            .collection("metadata")
            .doc("company-info")
            .get();

        data.companyInfo = coInfoData.data();
        return data;
    } catch (error) {
        console.log('error fetching aggregated data for company');
    }
}